import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import GenericTableReport from 'componentes/generic/GenericTableReport.js';
import FiltersDashboard from 'pages/Dashboards/_FiltersDashboard';
const URI = ApiEndpoint + 'reports/';

const ReporteQuejas = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();

  const [dataList, setDataList] = useState([]);

  const columns = [
    {
      accessorKey: 'expediente',
      header: 'Expediente', //Header: 'Info'
      headerProps: { className: 'pe-1' },
      id: 'expediente',
      cellProps: {
        className: 'py-2'
      },
      cell: rowData => {
        return (
          <>
            <strong>{rowData.row.original.expediente}</strong>
            <p className="mb-0 text-500">
              Fecha de Recepcion: {rowData.row.original.fecharecepcion || ''}
            </p>{' '}
            <p className="mb-0 text-500">
              Delegacion: {rowData.row.original.delegacion || ''}
            </p>
          </>
        );
      }
    },
    {
      id: 'determinante',
      accessorKey: 'determinante',
      header: 'Cliente', //'Customer'
      headerProps: { className: 'pe-7' },
      cell: rowData => {
        return (
          <>
            <strong>{rowData.row.original.proveedor}</strong>
            <p className="mb-0 text-500">
              <strong>Determinante:{rowData.row.original.determinante}</strong>
            </p>
            <p className="mb-0 text-500">
              {rowData.row.original.tipoproductoqueja}
            </p>
            <p className="mb-0 text-500">
              Folio Oracle: {rowData.row.original.vc_folioext || ''}
            </p>{' '}
          </>
        );
      }
    },
    {
      id: 'nombreconsumidor',
      accessorKey: 'nombreconsumidor',
      header: 'Datos de Queja', //'Location',
      headerProps: { className: 'pe-7' },
      cell: rowData => {
        return (
          <>
            <strong>{rowData.row.original.clasificacionqueja}</strong>
            <p className="mb-0 text-500">
              Fecha de Queja: {rowData.row.original.fechareporte}
            </p>
            <p className="mb-0 text-500">{rowData.row.original.status}</p>
            <p className="mb-0 text-500">{rowData.row.original.consumidor}</p>
          </>
        );
      }
    }
  ];
  const getQuejasList = async filters => {
    if (!filters) return;
    setDataList(null);

    httpClient(
      'POST',
      URI + 'quejas/',
      {
        from: filters.dateFrom,
        to: filters.dateTo,
        idCustomer: filters.idCustomer,
        idSubCustomer: filters.idSubCustomer
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setDataList(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getQuejasList();
  }, []);

  return (
    <>
      {' '}
      <Card
        className="bg-100 shadow-none border mb-3"
        style={{
          margin: '12px', // Margen externo (separación con otros elementos)
          padding: '16px' // Padding interno (espaciado del contenido hacia adentro)
        }}
      >
        <Row className="flex-end-center mb-3">
          <Col md={12}>
            <FiltersDashboard action={getQuejasList} useSubCustomers={true} />
          </Col>
        </Row>
        {dataList && (
          <GenericTableReport
            data={dataList}
            title="Quejas en el periodo"
            columns={columns}
            exportData={dataList}
          ></GenericTableReport>
        )}
      </Card>
    </>
  );
};

export default ReporteQuejas;
